export const PASSWORD_GET_REQUEST = 'PASSWORD_GET_REQUEST';
export const PASSWORD_GET_SUCCESS = 'PASSWORD_GET_SUCCESS';
export const PASSWORD_GET_FAILURE = 'PASSWORD_GET_FAILURE';
